import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectReport, Identifiable, Id } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  report: Identifiable<ProjectReport>;
  retrieveProjectReport(
    reportId: Boundaries["retrieveProjectReport"]["request"],
  ): void;
}

function useRetrieveProjectReport(reportId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectReportRequestPending(reportId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectReportRequestSuccess(reportId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectReportRequestFailure(reportId),
    ),
    report: useSelector(() => selector.getProjectReport(reportId)),
    retrieveProjectReport: core.retrieveProjectReport,
  };
}

export { useRetrieveProjectReport };
